Vue.asyncComponent('bp-scale-control', {
    data() {
        return {
            scaleOptions: [
                {
                    label: '100%',
                    value: 1
                },
                {
                    label: '75%',
                    value: .75
                },
                {
                    label: '50%',
                    value: .5
                },
                {
                    label: '25%',
                    value: .25
                },
            ],
            openPreviewScaleOptions: false
        }
    },
    props: {
        previewScale: {
            type: Number,
            required: false,
            default: 1
        },
    },
    computed: {
        localPreviewScaleLabel: {
            get() {
                return this.scaleOptions.find( option => option.value === this.previewScale)?.label;
            },
            set(e) {
                return this.$emit('changePreviewScale', e);
            }
        },
    },
    methods: {
        /**
         * Set the scale we want the preview to be renderd
         * @param value
         */
        setPreviewScale(value) {
            this.openPreviewScaleOptions = false;
            this.$emit('changePreviewScale', value);
        },
    }
}, 'blueprints/utils/scale/bp-scale-control.html');